import Header from "./components/Header";
import Hero from "./components/Hero";
import Ranking from "./components/Ranking";
import Serialized from "./components/Serialized";
import Featured from "./components/Featured";
import Category from "./components/Category";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Serialized />
        <Featured />
        <Category />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}